import { QuickCreateTaskModal } from 'app/components/tasks/QuickCreateTaskModal'
import { showModal } from 'app/lib/modal'
import type { ContactJson } from 'app/types/entities'

/** The quick-create window's chrome: it draws its own title and close button. */
const QUICK_CREATE_MODAL_OPTIONS = {
  hideTitle: true,
  isFullScreen: false,
  overflowHidden: false,
  removePadding: true,
  useRadix: true,
}

/** Opens quick-create, optionally starting on a due day or a contact. */
export function showQuickCreateTask({
  defaultDueDate,
  defaultContact,
  onCreated,
}: {
  defaultDueDate?: Date
  defaultContact?: ContactJson
  onCreated: () => void
}) {
  showModal(
    <QuickCreateTaskModal
      defaultDueDate={defaultDueDate}
      defaultContact={defaultContact}
      onTaskCreatedOrUpdated={onCreated}
    />,
    QUICK_CREATE_MODAL_OPTIONS,
  )
}
